import { render, staticRenderFns } from "./OrderActionModal.vue?vue&type=template&id=55b568b5&"
import script from "./OrderActionModal.vue?vue&type=script&lang=js&"
export * from "./OrderActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports